/** Deterministic shuffling, so an exercise looks the same after a reload. */

function hashString(text: string): number {
  let h = 2166136261;
  for (let i = 0; i < text.length; i += 1) {
    h ^= text.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return h >>> 0;
}

/** mulberry32 PRNG. */
function prng(seed: number): () => number {
  let a = seed;
  return () => {
    a = (a + 0x6d2b79f5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

/** Fisher–Yates shuffle seeded by `seed`; never returns the input order for 2+ distinct items. */
export function seededShuffle<T>(items: readonly T[], seed: string): T[] {
  const result = [...items];
  const next = prng(hashString(seed));
  for (let i = result.length - 1; i > 0; i -= 1) {
    const j = Math.floor(next() * (i + 1));
    [result[i], result[j]] = [result[j]!, result[i]!];
  }
  const unchanged = result.every((item, i) => item === items[i]);
  if (unchanged && new Set(items).size > 1) result.push(result.shift()!);
  return result;
}
